<template>
  <div
    class="BaseTabs"
    ref="tabs">
    <button
      v-for="tab in tabs"
      class="BaseTabs_Tab"
      :class="{ 'active': tab.value === value }"
      :key="tab.label"
      @click="handleTabClick(tab)">
      {{ tab.label }}
    </button>
    <div
      class="BaseTabs_ActiveIndicator"
      :style="activeIndicatorStyle">
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseTabs',

  data() {
    return {
      activeIndicatorStyle: this.getActiveIndicatorStyle(0, 0),
    };
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    tabs: {
      type: Array,
      default: () => [
        { label: 'Tab 1', value: 'tab1' },
        { label: 'Tab 2', value: 'tab2' },
      ],
    },
  },

  computed: {
    activeTab() {
      const activeTab = this.tabs.find((t) => t.value === this.value);
      return activeTab || this.tabs[0];
    },

    activeTabIndex() {
      return this.tabs.findIndex((t) => t.value === this.activeTab.value);
    },
  },

  watch: {
    activeTabIndex() {
      this.$nextTick(() => {
        this.setActiveIndicatorStyle();
      });
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.setActiveIndicatorStyle();
    });
  },

  methods: {
    handleTabClick(tab) {
      this.$emit('input', tab.value);
    },

    getActiveIndicatorStyle(width, translateX) {
      return {
        width: `${width}px`,
        transform: `translateX(${translateX}px)`,
      };
    },

    setActiveIndicatorStyle() {
      const activeTabRef = this.$refs.tabs.children[this.activeTabIndex];
      this.activeIndicatorStyle = this.getActiveIndicatorStyle(
        activeTabRef.offsetWidth,
        activeTabRef.offsetLeft,
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

$tab-height: 48px;
$active-indicator-height: 4px;

.BaseTabs {
  position: relative;
  text-align: left;
  white-space: nowrap;
}

.BaseTabs_Tab {
  display: inline-block;
  position: relative;
  height: 100%;
  margin: 0 12px;
  line-height: $tab-height - $active-indicator-height;
  color: rgba($dark, .8);
  font-size: 12px;
  font-weight: bold;
  letter-spacing: .5px;
  text-transform: uppercase;
  vertical-align: bottom;
  background-color: transparent;
  border: none;
  border-bottom: $active-indicator-height solid transparent;
  outline: none;
  &.active {
    color: $dark;
  }
}

.BaseTabs_ActiveIndicator {
  display: block;
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 0;
  height: $active-indicator-height;
  background-color: $light-blue;
  transform: translateX(0px);
  will-change: transform;
  transition: all .2s ease 0s;
}

.BaseTabs_Tab:hover,
.BaseTabs_Tab:focus {
  border-bottom-color: $border-color;
}
</style>
